import { PhoneIcon } from "@heroicons/react/outline";
import { ChipIcon, SupportIcon } from "@heroicons/react/solid";
import {
  AiOutlineCloudServer,
  AiOutlineDatabase,
  AiOutlineShoppingCart,
  AiOutlineUserSwitch,
} from "react-icons/ai";
import { BsCurrencyBitcoin, BsNewspaper } from "react-icons/bs";
import {
  MdOutlineBusiness,
  MdOutlineDeveloperMode,
  MdSecurity,
} from "react-icons/md";
import { RiMessage3Line, RiTeamLine } from "react-icons/ri";
import { VscServerProcess } from "react-icons/vsc";

/* --- Server --- */
export const SERVER_BASE = window.location.origin;

// export const SERVER_BASE =
//   "http://185.149.26.35:8940" || process.env.REACT_APP_SERVER_BASE_URL;
export const SERVER = SERVER_BASE + "/api/v1";

/* --- Requests --- */
export const REQ = {
  STATUS: SERVER_BASE,
  USER: {
    VERIFY: SERVER + "/auth/me",
    LOGIN: SERVER + "/login",
    REGISTER: SERVER + "/register",
    SUBSCRIBE: {
      PRODUCT: SERVER + "/user/refer/product",
    },
  },
  ALL_REPORTS: {
    GET_SALE_REG: SERVER + "/saleRegister",
  },
  ITEM: {
    ADD_ITEM: SERVER + "/createItem",
    GET_ITEM: SERVER + "/getItem",
    UPDATE_ITEM: SERVER + "/updateItem",
    DELETE_ITEM: SERVER + "/deleteItem",
    GET_ALL_ITEM: SERVER + "/getAllItem",
    GET_LATEST_ITEM_CODE: SERVER + "/getItemCode",
    GET_ITEM_RATE: SERVER + "/getItemRate",
    GET_ITEM_QUANTITY: SERVER + "/itemQuantity",
  },
  SALE_DATA: {
    GET_SALE: SERVER + "/getAllSale",
    GET_NOZEL: SERVER + "/getAllNozel",
    GET_TANK: SERVER + "/allTank",
    ESP_DATA: SERVER + "/ESPData",
    UPDATE_TANK: SERVER + "/updateTank",
  },

  REFRENCES: {
    GET_STITE_NAME: SERVER + "/findRefrence",
  },
  SEARCH: {
    ALL_ITEMS: SERVER + "/getAllItem",
  },
};

export const REGEX = {
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$/,
};

/* --- Errors --- */
export const ERR = {
  REFRESH: "Something went wrong, refresh to try again",
};

/* --- Support Data --- */
export const SUPPORT_DATA = [
  {
    icon: SupportIcon,
    title: "Consulting",
    description:
      "We help you create a clear digital strategy that optimizes your journey to total success in your technology-driven business.",
  },
  {
    icon: PhoneIcon,
    title: "Implementation",
    description:
      "Our expertise spans all key technologies and business functions, enabling us to provide comprehensive business solutions.",
  },
  {
    icon: ChipIcon,
    title: "Managed Services",
    description:
      "Our globally managed service teams secure your digital investment with 24/7 monitoring, maintenance and end-to-end support.",
  },
  {
    icon: ChipIcon,
    title: "BA",
    description:
      "Our experienced team, trained by business analysts, quickly supports your employees with timely, high-quality results.",
  },
];

/* --- All in One Data --- */
export const ALL_IN_ONE_DATA = [
  {
    icon: BsCurrencyBitcoin,
    title: "Blockchain",
  },
  {
    icon: AiOutlineShoppingCart,
    title: "Digital Commerce",
  },
  {
    icon: MdOutlineBusiness,
    title: "Business Application",
  },
  {
    icon: AiOutlineDatabase,
    title: "Data Management & Analytics",
  },
  {
    icon: VscServerProcess,
    title: "Business Process Outsourcing",
  },
  {
    icon: AiOutlineCloudServer,
    title: "Cloud Services",
  },
  {
    icon: MdOutlineDeveloperMode,
    title: "Application Development",
  },
  // {
  //   icon: MdOutlineIntegrationInstructions,
  //   title: "Application Integration",
  // },
  {
    icon: RiTeamLine,
    title: "Cloud Team",
  },
  {
    icon: MdSecurity,
    title: "Security",
  },
  {
    icon: BsNewspaper,
    title: "IT Infrastructure",
  },
  {
    icon: RiMessage3Line,
    title: "Quality Assurance",
  },
  {
    icon: AiOutlineUserSwitch,
    title: "User Experience",
  },
  // {
  //   icon: BsCurrencyBitcoin,
  //   title: "Application Modernization",
  // },
];
